import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { LocationCreateRequest } from '@core/models/location/location-create.request';
import { LocationUpdateRequest } from '@core/models/location/location-update.request';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class LocationsDataService extends BaseHttpService {

    private urls: any = {
        allLocations: '/locations?all=true',
        locations: '/locations',
        location: '/locations/:locationId',
        locationSchedules: '/locations/:locationId/schedules?all=true'
    };

    /**
     * Fetches ONLY locations & schedules that user session has access to.
     * @returns {Observable<any>}
     */
    fetchLocations(): Observable<any> {
        return this.get(this.urls.locations);
    }

    fetchAllLocations(): Observable<any> {
        return this.get(this.urls.allLocations);
    }

    /**
     * Fetches location and ONLY schedules that user session has access to.
     * @param {string} locationId
     * @returns {Observable<any>}
     */
    fetchLocation(locationId: string): Observable<any> {
        const url: string = environment.api.endpointV2 + this.urls.location.replace(':locationId', locationId);
        return this.get(url, undefined, true);
    }

    /**
     * Fetches ALL schedules on a location.
     * @param {string} locationId
     * @returns {Observable<any>}
     */
    fetchLocationSchedules(locationId: string): Observable<any> {
        return this.get(this.urls.locationSchedules.replace(':locationId', locationId));
    }

    updateLocation(locationId: string, request: LocationUpdateRequest) {
        const url: string = environment.api.endpointV2 + this.urls.location.replace(':locationId', locationId);
        return this.put(url, request, undefined, true);
    }

    createLocation(request: LocationCreateRequest) {
        const url: string = environment.api.endpointV2 + this.urls.locations;
        return this.post(url, request, undefined, true);
    }

    deleteLocation(locationId: string) {
        const url: string = environment.api.endpointV2 + this.urls.location.replace(':locationId', locationId);
        return this.delete(url, undefined, undefined, true);
    }
}